export enum BETA_FEATURES {
  Order_selected_date = 'order_selected_date',
  Invoices = 'invoices',
  Always_cashier = 'always_cashier',
  Allow_order_delete = 'allow_order_delete',
  Reports = 'reports',
  Home_page_blocks = 'home_page_blocks',
}